/** Format a timesheet WP/WU option as "CODE - Title", without duplicating identical values. */
export function formatTimesheetCodeTitleLabel(item: {
  code?: string | null;
  title?: string | null;
}): string {
  const code = (item.code || '').trim();
  const title = (item.title || '').trim();
  if (code && title && code !== title) {
    return `${code} - ${title}`;
  }
  return title || code;
}
